import { animate, animateChild, group, query, state, style, transition, trigger } from '@angular/animations';

const animationType: string = '300ms ease-out';

export const worksAnimation = trigger('worksAnimation', [
  transition('WorkList => WorkDetail', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'relative',
          top: 0,
          left: 0,
          width: '100%',
        }),
      ],
      { optional: true }
    ),
    query(
      ':enter',
      [
        style({
          transform: 'translateX(100%)',
        }),
      ],
      { optional: true }
    ),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(
        ':leave',
        [
          animate(
            animationType,
            style({
              transform: 'translateX(-100%)',
            })
          ),
        ],
        { optional: true }
      ),
      query(
        ':enter',
        [
          animate(
            animationType,
            style({
              transform: 'translateX(0%)',
            })
          ),
        ],
        { optional: true }
      ),
    ]),
    query(':enter', animateChild()),
  ]),
  transition('WorkDetail => WorkList', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'relative',
          top: 0,
          left: 0,
          width: '100%',
        }),
      ],
      { optional: true }
    ),
    query(':enter', [style({ transform: 'translateX(-100%)' })], { optional: true }),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(':leave', [animate(animationType, style({ transform: 'translateX(100%)' }))], { optional: true }),
      query(':enter', [animate(animationType, style({ transform: 'translateX(0%)' }))], { optional: true }),
    ]),
    query(':enter', animateChild(), { optional: true }),
  ]),
  transition('WorkDetail => TaskDetail', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'relative',
          top: 0,
          left: 0,
          width: '100%',
        }),
      ],
      { optional: true }
    ),
    query(
      ':enter',
      [
        style({
          transform: 'translateX(100%)',
        }),
      ],
      { optional: true }
    ),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(
        ':leave',
        [
          animate(
            animationType,
            style({
              transform: 'translateX(-100%)',
            })
          ),
        ],
        { optional: true }
      ),
      query(
        ':enter',
        [
          animate(
            animationType,
            style({
              transform: 'translateX(0%)',
            })
          ),
        ],
        { optional: true }
      ),
    ]),
    query(':enter', animateChild(), { optional: true }),
  ]),
  transition('TaskDetail => WorkDetail', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'relative',
          top: 0,
          left: 0,
          width: '100%',
        }),
      ],
      { optional: true }
    ),
    query(':enter', [style({ transform: 'translateX(-100%)' })], { optional: true }),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(':leave', [animate(animationType, style({ transform: 'translateX(100%)' }))], { optional: true }),
      query(':enter', [animate(animationType, style({ transform: 'translateX(0%)' }))], { optional: true }),
    ]),
    query(':enter', animateChild(), { optional: true }),
  ]),
  transition('TaskDetail => WorkList', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'relative',
          top: 0,
          left: 0,
          width: '100%',
        }),
      ],
      { optional: true }
    ),
    query(':enter', [style({ transform: 'translateX(-100%)' })], { optional: true }),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(':leave', [animate(animationType, style({ transform: 'translateX(100%)' }))], { optional: true }),
      query(':enter', [animate(animationType, style({ transform: 'translateX(0%)' }))], { optional: true }),
    ]),
    query(':enter', animateChild(), { optional: true }),
  ]),
]);

export const ticketsAnimation = trigger('ticketsAnimation', [
  transition('TicketList => TicketDetail', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'relative',
          top: 0,
          left: 0,
          width: '100%',
        }),
      ],
      { optional: true }
    ),
    query(
      ':enter',
      [
        style({
          transform: 'translateX(100%)',
        }),
      ],
      { optional: true }
    ),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(
        ':leave',
        [
          animate(
            animationType,
            style({
              transform: 'translateX(-100%)',
            })
          ),
        ],
        { optional: true }
      ),
      query(
        ':enter',
        [
          animate(
            animationType,
            style({
              transform: 'translateX(0%)',
            })
          ),
        ],
        { optional: true }
      ),
    ]),
    query(':enter', animateChild()),
  ]),
  transition('TicketDetail => TicketList', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'relative',
          top: 0,
          left: 0,
          width: '100%',
        }),
      ],
      { optional: true }
    ),
    query(':enter', [style({ transform: 'translateX(-100%)' })], { optional: true }),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(':leave', [animate(animationType, style({ transform: 'translateX(100%)' }))], { optional: true }),
      query(':enter', [animate(animationType, style({ transform: 'translateX(0%)' }))], { optional: true }),
    ]),
    query(':enter', animateChild(), { optional: true }),
  ]),
]);

export const resourcesAnimation = trigger('resourcesAnimation', [
  transition('ResourceList => ResourceEventVehicleMileage', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'relative',
          top: 0,
          left: 0,
          width: '100%',
        }),
      ],
      { optional: true }
    ),
    query(
      ':enter',
      [
        style({
          transform: 'translateX(100%)',
        }),
      ],
      { optional: true }
    ),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(
        ':leave',
        [
          animate(
            animationType,
            style({
              transform: 'translateX(-100%)',
            })
          ),
        ],
        { optional: true }
      ),
      query(
        ':enter',
        [
          animate(
            animationType,
            style({
              transform: 'translateX(0%)',
            })
          ),
        ],
        { optional: true }
      ),
    ]),
    query(':enter', animateChild()),
  ]),
  transition('ResourceEventVehicleMileage => ResourceList', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'relative',
          top: 0,
          left: 0,
          width: '100%',
        }),
      ],
      { optional: true }
    ),
    query(':enter', [style({ transform: 'translateX(-100%)' })], { optional: true }),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(':leave', [animate(animationType, style({ transform: 'translateX(100%)' }))], { optional: true }),
      query(':enter', [animate(animationType, style({ transform: 'translateX(0%)' }))], { optional: true }),
    ]),
    query(':enter', animateChild(), { optional: true }),
  ]),
]);

export const resultDetailExpand = trigger('resultDetailExpand', [
  state('collapsed', style({ height: '0px', minHeight: '0' })),
  state('expanded', style({ height: '*' })),
  transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
]);
